import type { ToasterProps } from "sonner"
import { Toaster as Sonner } from "sonner"

import { useAppearance } from "@/hooks/use-appearance"

const Toaster = ({ ...props }: ToasterProps) => {
  const { appearance } = useAppearance()
  const theme =
    appearance === "system"
      ? window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light"
      : appearance

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
